export enum AemComponentType {
  COLLAPSIBLE_LIST_V2 = 'platform-asadventure/components/general/collapsible-list/v2/collapsible-list',
  COLLAPSIBLE_LIST_ITEM_V2 = 'platform-asadventure/components/general/collapsible-list-item/v2/collapsible-list-item',
  TEXT_BLOCK_V2 = 'platform-asadventure/components/general/text-block/v2/text-block',
  TEASER_V2 = 'platform-asadventure/components/general/teaser/v2/teaser',
  CTA = 'platform-asadventure/components/general/call-to-action-button',
  DIVIDER = 'platform-asadventure/components/general/divider',
  VIDEO_V2 = 'platform-asadventure/components/general/video/v2/video',
  LIST_ITEM = 'platform-asadventure/components/general/list-item',
  LIST_V2 = 'platform-asadventure/components/general/list/v2/list',
}
